import { Fragment, memo } from 'react';
import PropTypes from 'prop-types';

import { formatDataTest } from '~/utils';

import styles from '../../section/Section.scss';

export const ShopDetails = memo(
  ({ shop: { name, address }, title, remoteShopAddress, hideShopAddress = false }) => (
    <Fragment>
      <dt
        className={`${styles.Section__question_title} ${styles.Section__column}`}
        data-testid={formatDataTest('shop details', 'title')}
      >
        {title}
      </dt>
      <dd
        className={`${styles.Section__question_definition} ${styles.Section__column}`}
        data-testid={formatDataTest('shop details')}
      >
        <p>{name}</p>
        {!hideShopAddress && <address>{remoteShopAddress || address}</address>}
      </dd>
    </Fragment>
  ),
);

ShopDetails.displayName = 'ShopDetails';

ShopDetails.propTypes = {
  title: PropTypes.string.isRequired,
  remoteShopAddress: PropTypes.string,
  hideShopAddress: PropTypes.bool,
  shop: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.string,
  }).isRequired,
};
